export default __webpack_public_path__ + "static/media/gallery_01.27a4b8d5.jpg";